import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getApiConfigs(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_APICONFIG_REQUESTED", "GET_APICONFIG_SUCCESS", "GET_APICONFIG_FAILED"],
        method: "POST",
        path: "admin/get_api_configs",
        body: data
    });
}

export function setDeveloperPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_DEVELOPER_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function deleteApiKey(apiId){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {api_Id: apiId};
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_APICONFIG_REQUESTED", "DELETE_APICONFIG_SUCCESS", "DELETE_APICONFIG_FAILED"],
        method: "POST",
        path: "admin/delete_api_configs",
        body: data
    });
}

export function createApiKey(api_config){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = api_config;
    appendTokenName(data);
    return apiAction({
        types: ["CREATE_APICONFIG_REQUESTED", "CREATE_APICONFIG_SUCCESS", "CREATE_APICONFIG_FAILED"],
        method: "POST",
        path: "admin/create_api_configs",
        body: data
    });
}

export function updateApiConfigs(api_config){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_api = api_config;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_APICONFIG_REQUESTED", "UPDATE_APICONFIG_SUCCESS", "UPDATE_APICONFIG_FAILED"],
        method: "POST",
        path: "admin/update_api_configs",
        body: data
    });
}


// WEBPACK FOOTER //
// ./src/actions/actionDevloper.js